export default __webpack_public_path__ + "static/media/i083sk.1a0c06bc.webp";